<template>
  <div class="bg-white rounded-lg shadow p-6">
    <h3 class="text-lg font-semibold text-gray-800">
      {{ title }}
      <span class="text-sm text-gray-500">{{ subtitle }}</span>
    </h3>
    <p class="text-sm text-gray-600 mt-2">
      {{ description }}
    </p>
    <div v-if="chartReady" class="mt-4">
      <apexchart
        type="pie"
        height="400"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </div>
    <div v-else class="text-gray-500 text-center py-8">
      Sin datos disponibles
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";

export default {
  name: "QualityReportsPieChart",
  components: {
    apexchart: VueApexCharts
  },
  data() {
    return {};
  },
  props: {
    title: { required: true, type: String },
    subtitle: { type: String },
    description: { type: String },
    labels: { required: true, type: Array, default: () => [] },
    series: { required: true, type: Array, default: () => [] },
    tooltipFormatter: { type: Function, default: val => val },
    colors: { type: Array, default: () => [] },
  },
  created() {},
  computed: {
    chartReady() {
      return this.series.length > 0;
    },

    chartOptions() {
      return {
        chart: {
          type: "pie",
          toolbar: { show: true }
        },
        labels: this.labels,
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return val.toFixed(1) + "%";
          }
        },
        tooltip: {
          y: {
            formatter: this.tooltipFormatter
          }
        },
        legend: {
          position: "bottom",
          horizontalAlign: "center"
        },
        colors: this.colors
      };
    }
  },
  methods: {},
  watch: {}
};
</script>
